// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Q5_NrDalutz8nk {
  padding: var(--ds-space-050, 3px) var(--ds-space-0, 0);
}
.QKouHll0rgZIrw {
  margin-bottom: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var disclaimerMessage = `Q5_NrDalutz8nk`;
export var addToWorkspaceButton = `QKouHll0rgZIrw`;
export default ___CSS_LOADER_EXPORT___;
